<div [ngBusy]="{busy: busy,message: 'Loading flow types...',backdrop: true,delay: 500,		minDuration: 50	}"></div>

<ngb-alert *ngIf="errorMessage.hasError()" [dismissible]="true" [type]="'danger'" (close)="errorMessage.reset()">
    <div>
        <strong>{{ errorMessage.title }}</strong>
    </div>
    <div>{{ errorMessage.message }}</div>
</ngb-alert>

<div class="col-lg-12 px-0" style="margin-top: -20px;">
    <ngb-accordion #acc="ngbAccordion" [activeIds]="['events']" class="small-accordion col-lg-12">
        <!--- Events -->
        <ngb-panel id="events" title="Events">
            <ng-template ngbPanelHeader let-opened="opened">
                <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
                    <div ngbPanelToggle class="d-lg-flex justify-content-between" (click)="acc.toggle('events');">
                        <span class="pointer"><strong>Events</strong></span>
                        <span class="pointer">
                            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
                            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template ngbPanelContent let-opened="opened" class="row">
                <div class="col-12 px-0">
                    <table class="table table-hover table-outline table-striped table-sm">
                        <thead>
                            <th style="min-width: 150px">Flow Instance ID</th>
                            <th>Step</th>
                            <th>Status</th>
                            <th>Time</th>
                            <th style="width: 30px" class="text-right;"></th>
                        </thead>

                        <tbody>
                            <tr *ngFor="let event of testEvent.events; let i = index">
                                <td>
                                    <input type="text" class="form-control form-control-sm"
                                        name="{{ i }}-value-flowInstanceId" placeholder="Insert event flowInstanceId*"
                                        [(ngModel)]="event.flowInstanceId" required>
                                </td>
                                <td>
                                    <ng-select [(ngModel)]="event.stepTypeCode" [items]="stepList" bindLabel="name"
                                        bindValue="code" placeholder="Select step" appendTo="body">
                                    </ng-select>

                                </td>
                                <td>
                                    <ng-select [items]="statusOptions" [(ngModel)]="event.status" bindLabel="name"
                                        bindValue="name" placeholder="Select status" name="{{ i }}-value-status"
                                        appendTo="body">
                                    </ng-select>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <app-control-bar-time-selector *ngIf="testEventCalendar == true"
                                            [content]="startTime" [widgetDefaultsActive]="false" [rangeDisabled]="true"
                                            (contentChange)="handleTimeChange($event, event)" [label]="null"
                                            [searchButton]="false">
                                        </app-control-bar-time-selector>
                                        <input *ngIf="testEventCalendar == false" class="form-control" type="number"
                                            [(ngModel)]="event.eventTs">

                                        <div class="input-group-append ml-1">
                                            <i *ngIf="testEventCalendar == true" (click)="testEventCalendar = false"
                                                class="mio vam px-2 rounded btn btn-secondary pointer">edit</i>
                                            <i *ngIf="testEventCalendar == false" (click)="testEventCalendar = true"
                                                class="mio vam px-2 rounded btn btn-secondary pointer">event</i>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <i *ngIf="i > 0" (click)="removeTestEvent(i)"
                                        class="mio vam px-0 text-muted float-right pointer btn">close</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 d-flex justify-content-end align-items-end px-0">
                    <button class="btn btn-outline-primary btn-sm mr-2" (click)="addTestEvent()">Add new
                        event</button>
                    <button type="button" class="btn btn-primary btn-sm"
                        (click)="sendTestEvent(); acc.expand('flow')">Test
                        Events</button>
                </div>
            </ng-template>
        </ngb-panel>
        <!-- Instance -->
        <ngb-panel id="instance" title="Instance">
            <ng-template ngbPanelHeader let-opened="opened">
                <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
                    <div ngbPanelToggle class="d-lg-flex justify-content-between" (click)="acc.toggle('instance');">
                        <span class="pointer"><strong>Instance</strong></span>
                        <span class="pointer">
                            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
                            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template ngbPanelContent let-opened="opened" class="row">
                <div class="col-12 px-0">
                    <small>Fill this if you want to send also an instance.</small>
                    <textarea [(ngModel)]="testEventInstanceString" class="form-control w-100" name="testEventInstance"
                        style="height: 100px"></textarea>
                </div>
            </ng-template>
        </ngb-panel>
        <!-- Flow -->
        <ngb-panel id="flow" title="flow">
            <ng-template ngbPanelHeader let-opened="opened">
                <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
                    <div ngbPanelToggle class="d-lg-flex justify-content-between" (click)="acc.toggle('flow');">
                        <span class="pointer"><strong>Flow Visualization</strong></span>
                        <span class="pointer">
                            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
                            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template ngbPanelContent let-opened="opened" class="row">
                <div class="col-12 px-0 w-100">
                    <app-drawflow-graph class="mt-2 w-100" [action]="action"
                        [drawFlowData]="content.drawFlowFullData.drawFlowData" [showInspectStats]="true"
                        [inspectData]="inspectData"></app-drawflow-graph>
                </div>
            </ng-template>
        </ngb-panel>
        <!-- Flow Instance Details -->
        <ngb-panel id="details" title="details">
            <ng-template ngbPanelHeader let-opened="opened">
                <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
                    <div ngbPanelToggle class="d-lg-flex justify-content-between" (click)="acc.toggle('details');">
                        <span class="pointer"><strong>Flow Instance Details</strong></span>
                        <span class="pointer">
                            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
                            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template ngbPanelContent let-opened="opened" class="row">
                <div class="col-12 px-0 w-100">
                    <table class="table table-sm table-hover table-striped table-sm table-outline table-event-details">
                        <tbody>
                            <tr *ngFor="let singleProperty of instanceDetailsData(testEventResponse); let idx = index">
                                <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;"
                                    class="text-left">
                                    <strong>{{singleProperty.key}}</strong>
                                </td>
                                <td style="word-break: break-all;">
                                    <code class="text-dark"
                                        *ngIf="singleProperty.type == 'timestamp'; else otherTypes">{{singleProperty.value | date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''}} - ({{singleProperty.value}})</code>
                                    <ng-template #otherTypes>
                                        <code class="text-dark">{{singleProperty.value}}</code>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</div>